import React from "react";
import { Link } from "react-router-dom";
import "./DetailProject.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { resolveMediaUrl } from "../../../../utils/mediaUrl";

function ContentImage({ src, caption }) {
  const url = resolveMediaUrl(src);
  return (
    <div className="work-details__image">
      {url ? (
        <img src={url} alt="" className="work-details__image-img" />
      ) : null}
      {caption ? <CmsText content={caption} as="span" /> : null}
    </div>
  );
}

const DetailProject = ({ project }) => {
  if (!project) return null;

  return (
    <section className="work-details">
      <div className="work-details__layout">
        <div className="work-details__container">
          <h3>Introduction</h3>

          <RichTextContent content={project.intro} />

          <ContentImage
            src={project.intro_image}
            caption={project.intro_image_caption}
          />

          {project.quote_text ? (
            <div className="work-details__quote">
              <RichTextContent content={project.quote_text} />
              {project.quote_author ? (
                <CmsText content={project.quote_author} as="span" />
              ) : null}
            </div>
          ) : null}

          <RichTextContent content={project.mid_body} />

          {project.software_tools_body ? (
            <>
              <CmsText content={project.software_tools_heading} as="h3" />
              <RichTextContent content={project.software_tools_body} />
            </>
          ) : null}

          {project.other_resources?.length ? (
            <>
              <CmsText content={project.other_resources_heading} as="h3" />
              <ul>
                {project.other_resources.map((item, index) => (
                  <li key={`resource-${index}`}>
                    <CmsText content={item} as="span" />
                  </li>
                ))}
              </ul>
            </>
          ) : null}

          <ContentImage
            src={project.content_image_2}
            caption={project.content_image_2_caption}
          />

          <RichTextContent content={project.post_image_body} />
        </div>

        <div className="work-details__sidebar">
          {project.client ? (
            <div className="sidebar__block">
              <h5>Client</h5>
              <CmsText content={project.client} as="p" />
            </div>
          ) : null}

          {project.services?.length ? (
            <div className="sidebar__block">
              <h5>Services</h5>
              <ul>
                {project.services.map((item, index) => (
                  <li key={`service-${index}`}>
                    <CmsText content={item} as="span" />
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          {project.tech?.length ? (
            <div className="sidebar__block">
              <h5>Tech stack</h5>
              <ul>
                {project.tech.map((item, index) => (
                  <li key={`tech-${index}`}>
                    <CmsText content={item} as="span" />
                  </li>
                ))}
              </ul>
            </div>
          ) : null}

          <Link
            to={project.connect_link || "/contact"}
            className="work-details__connect buttonclip"
          >
            <CmsText content={project.connect_text || "Let's connect"} as="span" />
          </Link>
        </div>
      </div>

      {project.conclusion ? (
        <div className="work-details__conclusion">
          <div className="work-details__conclusion-card">
            <CmsText
              content={project.conclusion_heading || "Conclusion"}
              as="h2"
            />
            <RichTextContent content={project.conclusion} />
          </div>
        </div>
      ) : null}
    </section>
  );
};

export default DetailProject;
